import type {SearchHistoryEntryDto} from 'src/typings';
import type SearchHistoryDataService from './search-history.data-service';

export class KpSearchHistoryService {
    public static serviceName = 'kpSearchHistoryService';

    /*@ngInject*/
    constructor(private searchHistoryDataService: SearchHistoryDataService) {
    }

    public async getSearchHistory(): Promise<SearchHistoryEntryDto[] | null> {
        try {
            return await this.searchHistoryDataService.getAll();
        } catch {
            return null;
        }
    }
}